// eslint-disable-next-line import/prefer-default-export
export function formatCustomHtml(text, vegeuId) {
  let txt = String(text);

  function replaceFirst(target, replacement, str) {
    const index = str.indexOf(target);
    // eslint-disable-next-line max-len
    return index === -1 ? str : str.slice(0, index) + replacement + str.slice(index + target.length);
  }

  // -- tags html --

  // link
  // eslint-disable-next-line max-len
  txt = txt.replace(
    /<re link="([^"]*)"/g,
    `<a ${vegeuId ? `href="#/entry/${vegeuId}"` : ''} style="font-weight:bold;text-transform:uppercase;"`,
  );
  txt = txt.replace(/<\/re>/g, '</a>');

  const fontTags = ['f1', 'f2', 'f3'];
  fontTags.forEach((tag) => {
    txt = txt.replace(new RegExp(`<${tag}>`, 'g'), '<font face="Gentium" style="font-weight:bold">');
    txt = txt.replace(new RegExp(`</${tag}>`, 'g'), '</font>');
  });

  txt = txt.replace(/<pos>/g, '<i>').replace(/<\/pos>/g, '</i>');
  txt = txt.replace(/<tr lang="ES">/g, '<trad lang="ES"><i>').replace(/<tr lang='ES'>/g, '<trad lang="ES"><i>').replace(/<\/tr>/g, '</i></trad>');
  txt = txt.replace(/<ng>/g, '<b>').replace(/<\/ng>/g, '</b>');
  txt = txt.replace(/<cs>/g, '<i>').replace(/<\/cs>/g, '</i>');
  txt = txt.replace(/<q type="MF">/g, '<b><i>').replace(/<\/q>/g, '</i></b>');

  const spanTags = ['cp', 'e', 'fn', 'sn', 'lo', 'in', 'va', 'rf', 'vr', 'cj'];
  spanTags.forEach((tag) => {
    txt = txt.replace(new RegExp(`<${tag}>`, 'g'), '<span class=\'versaleta\'>').replace(new RegExp(`</${tag}>`, 'g'), '</span>');
  });

  txt = txt.replace(/"/g, '\'');

  // -- https://mothereff.in/html-entities --

  // -- symbols
  txt = txt.replace(/&lguion;/g, '&mdash;');
  txt = txt.replace(/&oq;/g, '&#8216;');
  txt = txt.replace(/&cq;/g, '&#8217;');
  txt = txt.replace(/&oca;/g, '&#171;');
  txt = txt.replace(/&tca;/g, '&#187;');

  // phonetic replacements
  const phoneticEntities = {
    '&iefn;': '&#601;',
    '&shacekfn;': '&#643;',
    '&beta;': '&beta;',
    '&dbarfn;': '&eth;',
    '&iinvbrbfn;': '&#x458;',
    '&efn;': 'e',
    '&ranz;': '&#638;',
    '&galenisacu;': '&#x1F04;',
    '&amac;': '&#257;',
    '&oacutailfn;': '&#x254;&#x301;',
    '&eacudotbfn;': '&#xE9;',
    '&hdotbar;': '&#x1E25;',
    '&wfn;': '&#x77;',
    '&eacutailfn;': '&#x3B5;&#x301;',
    '&ibreve;': '&#x12D;',
    '&etailfn;': '&#x25B;',
    '&ofn;': '&#x6F;',
    '&chacekfn;': '&#x2A7;',
    '&zhacekfn;': '&#x292;',
    '&eacultailfn;': '&#x3B5;&#x301;&#x31E;',
    '&ghacekfn;': '&#x2A4;',
    '&ieacufn;': '&#x259;&#x301;',
    '&gatilde;': '&#x1FB6;',
    '&oacudotbfn;': '&#xF3;',
    '&emac;': '&#x113;',
    '&lbrbfn;': '&#x28E;',
    '&omac;': '&#x14D;',
    '&gbarbfn;': '&#x263;',
    '&nbrbfn;': '&#x272;',
    '&yetim;': '&#x79;',
    '&rmacfn;': '&#x72;',
    '&galenis;': '&#x1F00;',
    '&goacu;': '&#xF3;',
    '&gaacu;': '&#x1F71;',
    '&ebreve;': '&#x115;',
    '&zcircfn;': '&#x2A3;',
    '&rmac;': '&#x72;&#x304;',
    '&ainar;': '&#x2BF;',
    '&kbrbfn;': '&#x441;',
    '&imac;': '&#x12B;',
    '&lslashfn;': '&#x26B;',
    '&geacu;': '&#x1F73;',
    '&umac;': '&#x16B;',
    '&scircfn;': '&#x2A6;',
    '&hdot;': '&#x1E23;',
    '&zdotb;': '&#x1E93;',
    '&tdotb;': '&#x1E6D;',
    '&gelenisacu;': '&#x1F14;',
    '&oacultailfn;': '&#x254;&#x301;&#x31E;',
    '&giacu;': '&#x1F77;',
    '&ghacu;': '&#x1F75;',
    '&ntailfn;': '&#x14B;',
    '&gbrbfn;': '&#x25F;',
    '&obreve;': '&#x14F;',
    '&gbarbrbfn;': '&#x29D;',
    '&ain;': '&#x2BD;',
    '&sdotb;': '&#x1E63;',
    '&xetim;': 'x',
    '&qetim;': 'k',
    '&oqq;': '&#x201C;',
    '&cqq;': '&#x201D;',
  };

  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of Object.entries(phoneticEntities)) {
    txt = txt.replace(new RegExp(key, 'g'), value);
  }

  txt = txt.replace(/IV\. \|\|/g, '<br/><br/><span class=\'versaletaEntradaPrincipal\'>iv. ||</span>');
  txt = txt.replace(/V\. \|\|/g, '<br/><br/><span class=\'versaletaEntradaPrincipal\'>v. ||</span>');
  txt = txt.replace(/III\. \|\|/g, '<br/><br/><span class=\'versaletaEntradaPrincipal\'>iii. ||</span>');
  txt = txt.replace(/II\. \|\|/g, '<br/><br/><span class=\'versaletaEntradaPrincipal\'>ii. ||</span>');
  txt = txt.replace(/I\. \|\|/g, '<br/><span class=\'versaletaEntradaPrincipal\'>i. ||</span>');

  txt = txt.replace(/<sense/g, '<br/><sense');

  txt = replaceFirst('<br/>', '', txt);

  return txt;
}

export const handleShowTable = (entryName) => {
  const tableContainer = window.open(`https://ifbm.link/CEDULA_DCVB_TBL/${entryName.toLowerCase()}.htm`, '_blank', 'width=700,height=800');
  tableContainer.addEventListener('load', () => {
    document.querySelectorAll('td, th').forEach((cell) => {
      cell.removeAttribute('width');
      cell.style.removeProperty('width');
    });

    const style = tableContainer.document.createElement('style');
    style.textContent = `
      * {
        font-size: 12pt !important;
      }
      table, thead, tbody, tr, th, td {
        background: transparent !important;
        border: none !important;
        box-shadow: none !important;
        outline: none !important;
        border-collapse: separate !important;
        font-weight: 0 !important;
      }
      table {
        width: auto !important;
        border-collapse: separate !important;
        border-spacing: 0 8px !important;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important;
        font-size: 25px !important;
        background: transparent !important;
        box-shadow: none !important;
        border-radius: 12px !important;
        overflow: visible !important;
      }

      thead th {
        background: linear-gradient(135deg, #6b8cff, #88b4ff) !important;
        color: white !important;
        font-weight: 700 !important;
        padding: 10px 16px !important;
        text-align: left !important;
        border-top-left-radius: 12px !important;
        border-top-right-radius: 12px !important;
        box-shadow: 0 2px 8px rgba(107, 140, 255, 0.4) !important;
        border-left: 1px solid #00000012 !important;
        border-right: 1px solid #00000012 !important;
      }

      tbody tr {
        background: white !important;
        box-shadow: 0 2px 12px rgba(0,0,0,0.07) !important;
        border-radius: 12px !important;
        transition: transform 0.25s ease, box-shadow 0.25s ease !important;
      }

      tbody td {
        padding: 10px 16px !important;
        color: #2c3e50 !important;
        border-left: 1px solid #00000012 !important;
        border-right: 1px solid #00000012 !important;
        white-space: nowrap !important;
        border-top: none !important;
        border-bottom: none !important;
      }

      tbody tr:last-child td {
        border-bottom: none !important;
      }

      tbody tr:nth-child(even) {
        background: #f7f9ff !important;
      }
      `;
    tableContainer.document.head.appendChild(style);
  });
};
